import { useAsyncEffect, useNotifications, useRouter } from "@relode/core";
import qs from "qs";

import { ClientPublicMarketResearchActions } from "./clientPublicMarketResearchActions";
import { ClientPublicMarketResearchState } from "./clientPublicMarketResearchState";

export const useClientPublicMarketResearchSearchHandlers = (
    state: ClientPublicMarketResearchState,
    actions: ClientPublicMarketResearchActions
) => {
    const {
        location: { search },
    } = useRouter();
    const { actions: notifications } = useNotifications();

    useAsyncEffect(async () => {
        const queryString = qs.parse(search, { ignoreQueryPrefix: true });
        if (
            queryString &&
            Object.keys(queryString).length > 0 &&
            queryString.token &&
            typeof queryString.token === "string"
        ) {
            await actions.loadMarketResearch(queryString.token as string);
        } else {
            notifications.showArea(
                "info",
                "Currently, you can view specific market research only by clicking the link from your email.",
                "loadMarketResearch",
                {
                    canClose: false,
                }
            );
        }
    }, []);
};
